type CommitFile = { path: string; blobHash: string };

export function commitFilesDiffer(
  forkFiles: readonly CommitFile[],
  headFiles: readonly CommitFile[]
): boolean {
  if (forkFiles.length !== headFiles.length) return true;
  const forkByPath = new Map(forkFiles.map((f) => [f.path, f.blobHash]));
  for (const f of headFiles) {
    if (forkByPath.get(f.path) !== f.blobHash) return true;
  }
  return false;
}
